import { useContext } from 'react';
import { useHistory } from 'react-router-dom';
import { IBaseAction } from '../useAction';
import { AppContext } from '../../contexts/appContext';

export interface IUpdateSessionAction extends IBaseAction {
  type: 'update_session';

  data: {
    id: string;
    deviceId: string;
    relaunch: boolean;
    urlToOpen?: string;
  };
}

const useUpdateSessionAction = () => {
  const { saveSession } = useContext(AppContext);
  const history = useHistory();

  const handleUpdateSessionAction = (action: IUpdateSessionAction) => {
    const { id, deviceId, relaunch } = action.data;
    let { urlToOpen } = action.data;

    // Update session and optionally reinitialize app.
    // If relaunch is true, navigate to the root path to ensure the app is reinitialized with new window.location.pathname.
    // This is needed to avoid view layer requests being sent to the old path.
    if (relaunch && !urlToOpen) {
      // Preserve redirect param from current URL
      const params = new URLSearchParams(history.location.search);
      const redirect = params.get('redirect');

      // Navigate to root to trigger reinitialization
      history.push('/');

      // Pass redirect as urlToOpen so reinitializeApp uses it directly
      if (redirect) {
        urlToOpen = `/?redirect=${encodeURIComponent(redirect)}`;
      }
    }

    saveSession(id, deviceId, relaunch, urlToOpen);
  };

  return handleUpdateSessionAction;
};

export default useUpdateSessionAction;
